<script setup>
import { nextTick, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useStoreGetters, useStore } from 'dashboard/composables/store';
import { useAlert as wgptUseAlert } from 'dashboard/composables/wgpt';
import { useAlert } from 'dashboard/composables';

import SnackbarContainer from 'next/wgpt/Snackbar/SnackbarContainer.vue';
import Dialog from 'next/dialog/Dialog.vue';
import CreateStageForm from './CreateStageForm.vue';

const emit = defineEmits(['close']);
const store = useStore();
const getters = useStoreGetters();
const { t } = useI18n();

const dialogRef = ref(null);
const bot = ref({});
const workflow = ref({});
const isOpen = ref(false);
const uiFlags = getters['wgptBotWorkflowStages/getUIFlags'];

const onClose = () => {
  isOpen.value = false;
  emit('close');
};

const formRef = ref(null);

const open = (selectedBot, selectedWorkflow) => {
  bot.value = selectedBot;
  workflow.value = selectedWorkflow;
  isOpen.value = true;
  nextTick(() => {
    if (!dialogRef.value) return;
    dialogRef.value.open();
  });
};

const close = () => {
  dialogRef.value.close();
  onClose();
};

const handleSubmit = async () => {
  try {
    if (!formRef.value) return;
    const { validate } = formRef.value;

    const data = await validate();
    if (!data) return;

    const stage = {
      ...data,
    };
    await store.dispatch('wgptBotWorkflowStages/create', {
      ...stage,
      botId: bot.value.id,
      workflowId: workflow.value.id,
    });

    useAlert(
      t('WGPT_BOTS.EDIT.TABS.WORKFLOWS.STAGE.CREATE.API.SUCCESS_MESSAGE')
    );
    close();
  } catch (error) {
    const errorMessage =
      error?.response?.message ||
      t('WGPT_BOTS.EDIT.TABS.WORKFLOWS.STAGE.CREATE.API.ERROR_MESSAGE');
    wgptUseAlert(errorMessage);
  }
};

defineExpose({ open, close });
</script>

<template>
  <Dialog
    ref="dialogRef"
    :title="t('WGPT_BOTS.EDIT.TABS.WORKFLOWS.STAGE.CREATE.TITLE')"
    :confirm-button-label="t('WGPT_BOTS.EDIT.TABS.WORKFLOWS.STAGE.CREATE.SAVE')"
    :cancel-button-label="
      t('WGPT_BOTS.EDIT.TABS.WORKFLOWS.STAGE.CREATE.CANCEL')
    "
    :is-loading="uiFlags.isCreating"
    :disable-confirm-button="uiFlags.isCreating"
    @confirm="handleSubmit"
    @close="onClose"
  >
    <SnackbarContainer class="-top-6 fixed -translate-y-full" />
    <CreateStageForm v-if="isOpen" ref="formRef" @submit="handleSubmit" />
  </Dialog>
</template>
